export const ARCHIVES_CLOUD_TYPE = 'archivesCloudType';
export const JOBS_SIZE = 20;
export const MAX_DAYS = 61;

/**
 * Connector detection regex
 * matches AND/OR if it's outside of double quote.
 * eg. connector detected: name:foo and browser:"Internet Explorer 11"
 * eg. not detected: name:"foo and bar"
 */
export const CONNECTOR_REGEX = /(?:\s+(AND|OR)\s*)(?=(?:[^"]*"[^"]*")*[^"]*$)/gi;
